import { useTranslation } from "react-i18next";
import "./WarrantyBadge.css";
import { ShieldCheck } from "lucide-react";

export default function WarrantyBadge() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "en";

  // const text = t("warrantyBadge.text"); // "ضمان 5 سنوات" أو "5-Year Warranty"
  const text = "• 5 years warently • ضمان 5 سنوات"; // "ضمان 5 سنوات" أو "5-Year Warranty"
  const spacedText = text.split(" ").join("\u00A0"); // مسافتان غير قابلتان للكسر بين الكلمات

  return (
    <div className="warranty-container">
      <svg
        // className={`text-circle ${isArabic ? "rtl" : ""}`}
        className={`text-circle `}
        viewBox="0 0 200 200"
        width="200"
        height="200"
      >
        <defs>
          {/* all */}

          {
            <path
              id="circlePath"
              d="
                M 100,100
                m -75,0
                a 75,75 0 1,1 150,0
                a 75,75 0 1,1 -150,0
              "
            />
          }

          {/* English path */}
          {/* {!isArabic && (
            <path
              id="circlePath"
              d="
                M 100,100
                m -75,0
                a 75,75 0 1,1 150,0
                a 75,75 0 1,1 -150,0
              "
            />
          )} */}

          {/* Arabic reversed path */}
          {/* {isArabic && (
            <path
              id="circlePath"
              d="
    M 100,100
    m 90,0
    a 90,90 0 1,0 -180,0
    a 90,90 0 1,0 180,0
  "
            />
          )} */}
        </defs>

        <text>
          <textPath
            href="#circlePath"
            startOffset={isArabic ? "50%" : "50%"}
            textAnchor="middle"
          >
            {
              isArabic
                ? `  ${spacedText}` // العربية تكرر 3 مرات
                : `${spacedText}` // الإنجليزية تكرر 2 مرة
            }
            {/* {
              isArabic
                ? `•   ${spacedText} • ${spacedText} • ${spacedText}` // العربية تكرر 3 مرات
                : `${spacedText} • ${spacedText} • ${spacedText}` // الإنجليزية تكرر 2 مرة
            } */}
          </textPath>
        </text>
      </svg>

      <div className="icon-center">
        <ShieldCheck size={45} />
      </div>
    </div>
  );
}
